import {vote1Video,vote2Video} from "../../network/app/activity";
import {actConfig} from "./actConfig";
import {errDailog} from "./errDialog";

export function userVote1(that, item){
    var bizContent = {
        'userId': item.userId,
        'activityId': actConfig.getData().activityId
    }
    vote1Video(bizContent).then(res=>{
        // console.log('参赛页1-投票成功');
        // console.log(res)

        that.$myDialog({
            logo: 'null',
            text: '投票成功！',
            btnOK: "确定",
            callBack: (state)=>{}
        });

        item.voteNum1++
    }).catch(err=>{
        switch (err.code){
            // case 17009: //已过投票截止时间
            //     that.$myDialog({
            //         logo: 'null',
            //         text: '投票已经结束！',
            //         btnOK: "确定",
            //         callBack: (state)=>{}
            //     });
            //     break;
            // case 17012: //用户投票超额
            //     that.$myDialog({
            //         logo: 'null',
            //         text: '每天只能投1票，请明天再来吧！',
            //         btnOK: "确定",
            //         callBack: (state)=>{}
            //     });
            //     break;
            default:
                if (err.code==10005){

                }else{
                    that.$myDialog({
                        logo: 'null',
                        text: err.msg,
                        btnOK: "确定",
                        callBack: (state)=>{}
                    });
                }

                break;
        }
        console.log('参赛页1-投票失败');
        console.log(err)
    }).finally(()=>{})
}

export function userVote2(that, item){
    var bizContent = {
        'userId': item.userId,
        'activityId': actConfig.getData().activityId
    }
    vote2Video(bizContent).then(res=>{
        // console.log('参赛页2-投票成功');
        // console.log(res)

        that.$myDialog({
            logo: 'null',
            text: '投票成功！',
            btnOK: "确定",
            callBack: (state)=>{}
        });
        item.voteNum2++
    }).catch(err=>{
        switch (err.code){
            // case 17009: //已过投票截止时间
            //     that.$myDialog({
            //         logo: 'null',
            //         text: '投票已经结束！',
            //         btnOK: "确定",
            //         callBack: (state)=>{}
            //     });
            //     break;
            // case 17012: //用户投票超额
            //     that.$myDialog({
            //         logo: 'null',
            //         text: '每天只能投1票，请明天再来吧！',
            //         btnOK: "确定",
            //         callBack: (state)=>{}
            //     });
            //     break;
            default:
                if (err.code==10005){

                }else{
                    that.$myDialog({
                        logo: 'null',
                        text: err.msg,
                        btnOK: "确定",
                        callBack: (state)=>{}
                    });
                }
                break;
        }
        console.log('参赛页2-投票失败');
        console.log(err)
    }).finally(()=>{})
}
